// Pure layout math for frame images and plain-image crop. No DOM access —
// fully unit-testable. All values are px in frame-local (unzoomed) space.

// CSS box for the inner <img> of a frame-like object:
//   { width, height, fit, image: { offsetX, offsetY, scale } }
export function computeFrameImageLayout(frame, naturalWidth, naturalHeight) {
  const fw = Number(frame.width) || 1;
  const fh = Number(frame.height) || 1;
  const fit = frame.fit || 'cover';
  const img = frame.image || {};

  let w = fw;
  let h = fh;
  if (naturalWidth > 0 && naturalHeight > 0 && fit !== 'fill' && fit !== 'stretch') {
    const s = fit === 'contain'
      ? Math.min(fw / naturalWidth, fh / naturalHeight)
      : Math.max(fw / naturalWidth, fh / naturalHeight); // cover
    w = naturalWidth * s;
    h = naturalHeight * s;
  }

  const scale = Number(img.scale) || 1;
  w *= scale;
  h *= scale;

  return {
    left: (fw - w) / 2 + (Number(img.offsetX) || 0),
    top: (fh - h) / 2 + (Number(img.offsetY) || 0),
    width: w,
    height: h,
  };
}

// Clamp pan offsets so a cover-fit image always covers the frame.
// Non-cover fits pan freely (Canva behavior).
export function clampCropOffsets(frame, naturalWidth, naturalHeight, offsetX, offsetY) {
  if ((frame.fit || 'cover') !== 'cover') return { offsetX, offsetY };
  const centered = {
    ...frame,
    image: { ...(frame.image || {}), offsetX: 0, offsetY: 0 },
  };
  const { width: w, height: h } = computeFrameImageLayout(centered, naturalWidth, naturalHeight);
  const fw = Number(frame.width) || 1;
  const fh = Number(frame.height) || 1;
  const maxX = Math.max(0, (w - fw) / 2);
  const maxY = Math.max(0, (h - fh) / 2);
  return {
    offsetX: Math.min(maxX, Math.max(-maxX, offsetX)),
    offsetY: Math.min(maxY, Math.max(-maxY, offsetY)),
  };
}

// Lower bound for the crop-zoom slider.
export function minCropScale(fit) {
  return (fit || 'cover') === 'cover' ? 1 : 0.2;
}
